import React, { useState, useEffect } from "react";
import TopNavigation from "../../../components/TopNavigation";
import NoQuiz from "../NoQuiz";
import * as Assets from "../../../utils/svg_assets";
import * as PageRoutes from "../../../utils/route_pages";
import { connect } from "react-redux";
import { Base } from "../../../components/RootLayout";
import { Card, Row, Col } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import { InformationDialog } from "../../../components/DialogCollection";
import ApiUtils from "../../../utils/api_utils";
import "./style.scss";

const StartQuestion = (props) => {
  const navigate = useNavigate();
  const params = useParams();
  const { getListQuestion, submitQuestion } = props;

  const [index, setIndex] = useState(0);
  const [result, setResult] = useState([]);
  const [isModal, setIsModal] = useState(false);
  const [detailQuestion, setDetailQuestion] = useState([]);
  const [pointResult, setPointResult] = useState({});

  const detail = detailQuestion?.questions;

  const getDetails = async () => {
    const { data, status } = await getListQuestion(params.quizId);
    if (status == 200) {
      setDetailQuestion(data);
    }
  };

  useEffect(() => {
    getDetails();
  }, []);

  const handleButtonBack = () => {
    if (index > 0) {
      setIndex(index - 1);
    } else {
      navigate(PageRoutes.quiz + `/${params.categoryId}`);
    }
  };

  const handleButtonNext = () => {
    if (index + 1 < detail.length) {
      setIndex(index + 1);
    }
  };

  const handleButtonSubmit = async () => {
    let resultData = result.map((a, index) => ({
      answer: a.answer,
      id: a.id,
    }));
    let dataPost = {
      answers: resultData,
    };
    const { data, message, status } = await submitQuestion({
      id: detailQuestion.id,
      data: dataPost,
    });
    if (status == 200) {
      setIsModal(true);
      setPointResult(data);
    }
  };

  const handleClickAnswer = (answer, idx) => {
    let answerPush = {
      answer: answer,
      id: detail[index].id,
      index: index,
    };
    let resultAns = [...result];
    if (resultAns.length > 0) {
      let searchIdx = resultAns.findIndex((a) => a.id == detail[index].id);
      if (searchIdx == -1) {
        resultAns.push(answerPush);
        setResult(resultAns);
      } else {
        resultAns.splice(searchIdx, 1);
        resultAns.push(answerPush);
        setResult(resultAns);
      }
    } else {
      resultAns.push(answerPush);
      setResult(resultAns);
    }
  };

  if (detail?.length == undefined) {
    return (
      <Base>
        <TopNavigation
          titlePage="Quiz"
          toPath={-1}
          setBorder={true}
          showRightIcon={false}
          iconLeft={Assets.iconBack}
          iconRight={Assets.iconFilter}
        />
        <NoQuiz />
      </Base>
    );
  }

  return (
    <Base>
      <TopNavigation
        titlePage="Quiz"
        toPath={-1}
        setBorder={true}
        showRightIcon={false}
        iconLeft={Assets.iconBack}
        iconRight={Assets.iconFilter}
        showRightText={true}
        rightText={`${index + 1}/${detail?.length}`}
      />
      <div className="start-question-content">
        <div className="question-wrapper">
          <span>{detail[index].title}</span>
        </div>
        <Card className="card-image">
          <div
            className="image-bg"
            style={{
              backgroundImage:
                detail[index].image == null || detail[index].image == ""
                  ? `url(${
                      process.env.PUBLIC_URL + "/SKOR-Default-Quiz-Image.png"
                    })`
                  : `url(${ApiUtils.validateImgUrl({
                      url: detail[index].image,
                    })}`,
            }}
          />
        </Card>
        {detail[index].options.map((a, indexOptions) => (
          <div
            className={
              result.filter((b) => b.answer == a.option && b.index == index)
                .length > 0
                ? "btn card-answer active"
                : "btn card-answer"
            }
            key={indexOptions}
            onClick={() => handleClickAnswer(a.option, indexOptions)}
          >
            <Row>
              <Col md={10} sm={10} xs={10} className="text-start">
                <span
                  className={
                    result.filter(
                      (b) => b.answer == a.option && b.index == index
                    ).length > 0
                      ? "warning"
                      : ""
                  }
                >
                  {a.option}
                </span>
              </Col>
              <Col
                md={2}
                sm={2}
                xs={2}
                className={
                  result.filter((b) => b.answer == a.option && b.index == index)
                    .length > 0
                    ? "icon-wrapper"
                    : "icon-wrapper-none"
                }
              >
                <img src={Assets.iconCheckQuiz} alt="logo_image" />
              </Col>
            </Row>
          </div>
        ))}
        <Row className="btn-wrapper">
          <Col md={6} sm={6} xs={6}>
            <div className="btn btn-style outline" onClick={handleButtonBack}>
              Back
            </div>
          </Col>
          <Col md={6} sm={6} xs={6}>
            <div
              className={
                result.length >= index + 1
                  ? "btn btn-style warning"
                  : "btn btn-style warning disabled"
              }
              onClick={
                index + 1 == detail.length
                  ? handleButtonSubmit
                  : handleButtonNext
              }
              disabled={true}
            >
              {index + 1 == detail.length ? "Submit" : "Next"}
            </div>
          </Col>
        </Row>
        <InformationDialog
          message="Submit Quiz Success"
          closeLabel="OK"
          show={isModal}
          onHide={() => {
            navigate(
              PageRoutes.quiz + `/${params.categoryId}/${params.quizId}/result`,
              {
                state: pointResult,
              }
            );
          }}
        />
      </div>
    </Base>
  );
};

const mapStateToProps = (state) => ({
  detailQuestion: state.QuizSM.detailQuestion,
});

const mapDispatchToProps = (dispatch) => ({
  getListQuestion: dispatch.QuizSM.getListQuestion,
  submitQuestion: dispatch.QuizSM.submitQuestion,
});

export default connect(mapStateToProps, mapDispatchToProps)(StartQuestion);
